export const BEFORE_LABEL_ID = 'road-label';
